import { Alert, Button, Divider, Grid, MenuItem, Stack, Typography } from "@mui/material";
import useCheckoutStore from "../../../../../stores/public/useCheckoutStore";
import WushTextField from "../../../../form/WushTextField";
import Calendar from "@demark-pro/react-booking-calendar";
import { useEffect, useState } from "react";
import getPriceEstimate from "../../../../../api/public/reservations/getPriceEstimate";
import update from "../../../../../api/public/storePages/reservations/update";
import create from "../../../../../api/public/storePages/reservations/create";
import PageLoading from "../../../../layout/PageLoading";
import checkAvailability from "../../../../../api/auth/reservations/checkAvailability";

export default function ReservationInformationForm({register, getValues, setValue, handleSubmit, nextStep, previousStep}) {
  const [ outOfStock, setOutOfStock ] = useState([]);

  const { storePage, setReservation, reservation, setPricePreview, selectedBookableDuration, setSelectedBookableDuration,
          selectedDates, setSelectedDates
        } = useCheckoutStore();

  const fetchPrice = () => {
    getPriceEstimate({
      reservation_items: getValues('reservation_items'),
      start_at: selectedDates[0],
      end_at: selectedDates[1],
      bookable_duration_id: selectedBookableDuration
    }, (response) => {
      setPricePreview(response.price);
    }, (error) => {
      console.log(error);
    });
  };


  useEffect(() => {
    fetchPrice();
  }, [selectedDates, selectedBookableDuration]);

  const handleChange = (e) => {
    // console.log(e);
    // if(selectedDates.length === 2) {
    //   setSelectedDates([e[1]])
    // } else if(isAfter(e[0], e[1])) {
    //   setSelectedDates([e[1]]);
    // } else {
    //   setSelectedDates(e);
    // }
    setSelectedDates(e);
  };

  const onSubmit = (data) => {
    if(reservation?.id) {
      console.log('update');
      update(storePage.id, reservation.id, {
        reservation_items: data.reservation_items,
        start_at: selectedDates[0],
        bookable_duration_id: selectedBookableDuration
      }, (reservationResponse) => {
        setReservation(reservationResponse);
        checkAvailability(reservationResponse.id, (response) => {
          if(response.out_of_stock.length === 0) {
            setPricePreview(parseFloat(reservationResponse.total_price_dollars) * 100);
            nextStep();
          } else {
            setOutOfStock(response.out_of_stock);
          }
        });
      });
    } else {
      console.log({selectedDates, ...data});
      create(storePage.id, {
        reservation_items: data.reservation_items,
        start_at: selectedDates[0],
        bookable_duration_id: selectedBookableDuration
      }, (reservationResponse) => {
        checkAvailability(reservationResponse.id, (response) => {
          if(response.out_of_stock.length === 0) {
            setReservation(reservationResponse);
            setPricePreview(parseFloat(reservationResponse.total_price_dollars) * 100);
            nextStep();
          } else {
            setOutOfStock(response.out_of_stock);
          }
        });
      }, (error) => {
        console.log(error);
      });
    }
  };

  console.log(storePage);

  if(!storePage) return <PageLoading />;

  return (
    <Stack>
      <Stack>
        <Stack>
          <Typography variant="h6" fontWeight="700" color={storePage.primary_color}>
            {storePage.organization?.name}
          </Typography>
        </Stack>
        <Typography variant="h4" color={storePage.primary_color}>
          {storePage.name}
        </Typography>
        <Stack>
          <div dangerouslySetInnerHTML={{ __html: storePage.content }}></div>
        </Stack>
        <Stack my={2}>
          <Divider />
        </Stack>
        <Stack mb={4}>
          <Stack mb={2}>
            <Typography variant="h6" fontWeight="700">
              Select Items
            </Typography>
          </Stack>
          <Stack>
            {storePage.items?.map((item) => (
              <Grid key={item.id} container mb={1}>
                <Grid item sm={8}>
                  <Typography variant="h6">{item.name}</Typography>
                </Grid>
                <Grid item sm={4}>
                  <WushTextField
                    sx={{ display: 'none' }}
                    formRegistration={register(`reservation_items[${item.id}][item_id]`)}
                    defaultValue={item.id}
                  />
                  <WushTextField
                    label="Quantity"
                    formRegistration={register(`reservation_items[${item.id}][quantity]`, { onBlur: fetchPrice })}
                    type="number"
                    defaultValue={0}
                  />
                </Grid>
              </Grid>
            ))}
          </Stack>
        </Stack>
        {outOfStock.length > 0 && outOfStock.map((item) => (
          <Stack key={item.id} mb={1}>
            <Alert severity="error">
              There are only {item.available} {item.name}s available for this date
            </Alert>
          </Stack>
        ))}
        <Stack direction="row" spacing={2}>
          <Stack width="50%">
            <Stack mb={2}>
              <Typography variant="h6" fontWeight="700">
                Select Date
              </Typography>
            </Stack>
            <Calendar
              selected={selectedDates}
              onChange={handleChange}
              // onOverbook={(e, err) => alert(err)}
              // disabled={(date, state) => !state.isSameMonth}
              // reserved={reserved}
              variant="events"
              // dateFnsOptions={{ weekStartsOn: 1 }}

              range={false}
            />
          </Stack>


          {selectedDates.length > 0 && <Stack width="50%">
            <Stack mb={2}>
              <Typography variant="h6" fontWeight="700">
                Select Duration
              </Typography>
            </Stack>
            <Stack mb={2}>
              <WushTextField
                label="Booking option"
                formRegistration={{ onChange: (e) => {
                  setValue('bookable_duration_id', e.target.value);
                  setSelectedBookableDuration(e.target.value);
                }}}
                defaultValue={selectedBookableDuration}
                select
                autoFocus
              >
                {storePage.bookable_durations?.map((duration) => (
                  <MenuItem key={duration.id} value={duration.id}>
                    {duration.name}
                  </MenuItem>
                ))}
              </WushTextField>
            </Stack>
          </Stack>}
        </Stack>
      </Stack>
      <Stack direction="row" width="100%" justifyContent="center">
        <Button onClick={previousStep}>Back</Button>
        <Button disabled={!selectedBookableDuration} variant="contained" onClick={handleSubmit(onSubmit)}>Next</Button>
      </Stack>
    </Stack>
  );
}